// import NotFoundView from '@/components/mainView/views/notFoundView/NotFoundView.vue'
import ProjectsView from '@/components/mainView/views/projectsView/ProjectsView.vue'
import CustomersView from '@/components/mainView/views/customersView/CustomersView.vue'
import HomeView from '@/components/mainView/views/homeView/HomeView.vue'
// import IntroView from '@/components/mainView/views/introView/IntroView.vue'
import LegalsView from '@/components/mainView/views/legalsView/LegalsView.vue'
import MainView from '@/components/mainView/MainView.vue'
// import UrlParser from '@/components/mainView/views/homeView/components/urlParser/UrlParser.vue'
// Routes
const routes = [

  {
    path: '/:lang',
    component: MainView,
    children: [
      /* {
        path: '/',
        name: 'intro',
        component: IntroView
      }, */
      {
        path: '/',
        name: 'about',
        component: HomeView
      },
      {
        path: 'projects',
        name: 'projects',
        component: ProjectsView
      },

      {
        path: 'customers',
        name: 'customers',
        component: CustomersView
      },
      {
        path: 'legals',
        name: 'legals',
        component: LegalsView
      }
    ]
  }
]

export default routes
